import { Component, Input, OnInit, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisPlamComponent } from '../../structure/component/plam/his-plam.component';
import { HisUploadFile } from '../model/his-upload-file';
import { HisAbstractFileUploadComponent } from './his-abstract-file-upload.component';

/**
 *
 * {@link https://stackoverflow.com/questions/50618050/how-to-create-custom-input-component-with-ngmodel-working-in-angular-6}
 */
@Component( {
    selector: 'his-file-upload[configKey]',
    templateUrl: './his-file-upload.component.html',
    styleUrls: ['./his-file-upload.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisFileUploadComponent extends HisAbstractFileUploadComponent implements OnInit {
    private plam = inject<HisPlamComponent>(HisPlamComponent, { optional: true });


    // Komponente in JSF: his:inputFile
    @Input() configKey: string;

    @Input() model: HisUploadFile[] = [];

    @Input() label: string;


    ngOnInit() {
        super.ngOnInit();

        if ( this.label ) {
            this.plam.label = this.label;
        }
    }

    get uploadButtonTitle() {
        if ( this.label ) {
            return this.label;
        }

        const label = this.hisUiService.translate( this.ddLabeltext );
        if ( !this.required ) {
            return label;
        }

        return HisPlamComponent.REQUIRED_INDICATOR + ' ' + label;
    }

    get uploadButtonAriaLabel() {
        return this.uploadButtonTitle + ' ' + this.getInternalUploadFieldLabel();
    }

    get plamRef(){
        return this.plam;
    }

}
